// extracted by mini-css-extract-plugin
export default {"root":"legend_root__qwTOR","pointers":"legend_pointers__cB14B","placeHolderShimmer":"legend_placeHolderShimmer__FwbIv"};